import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config'; // Importing configuration constants

/**
 * Class representing the FilterClosingDayReportView.
 * @extends JetView
 */
export default class FilterClosingDayReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Datepicker input
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'combo', // Combo box for BetShop selection
                            name: 'BetShopId',
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Label for BetShop
                            hidden: !devConfig.getPermAction('filterByBetShop', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByBetShop',
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            id: 'BetShopId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed function for combo box
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length > 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type for AJAX request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect', // API endpoint
                                                    '{"Filter":"' + text + '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse response text
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Populate combo box with data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'text', // User email input
                            name: 'User',
                            label: "<span class='icon-mail'></span>" + _('Usuario (Correo electrónico)'), // Label for user input
                            labelPosition: 'top',
                            placeholder: _('Usuario (Correo electrónico)'), // Placeholder text
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 180 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include left section in upper section
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout adjustment
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values on click
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Button label
                            hotkey: 'enter', // Hotkey for button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('closingDay:filter', [
                                    filterdata, // Trigger filter event with form data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main form view
            rows: [upper_section, buttons], // Include upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
